<template>
  <section v-if="banners.length" class="section02">
    <div class="swiper visual-wrap" ref="swiperContainer">
      <div class="swiper-wrapper">
        <div
            class="swiper-slide"
            v-for="(banner, idx) in banners"
            :key="idx"
        >
          <figure
              @click="banner.linkUrl && goToUrl(banner.linkUrl)"
              :style="{ cursor: banner.linkUrl ? 'pointer' : 'default' }"
          >
            <template v-if="banner.mediaType === 'MP4'">
              <video autoplay muted loop playsinline>
                <source :src="banner.imageUrl" type="video/mp4" />
              </video>
            </template>
            <template v-else>
              <img :src="banner.imageUrl" alt="Banner Image" loading="lazy" />
            </template>
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch, nextTick } from 'vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const props = defineProps({
  banners: {
    type: Array,
    default: () => [],
  },
});

const swiperInstance = ref(null);
const swiperContainer = ref(null);
const windowWidth = ref(window.innerWidth);

// 링크 이동 함수
const goToUrl = (linkUrl = false) => {
  if (linkUrl) {
    const url = linkUrl.startsWith('http') ? linkUrl : 'https://' + linkUrl;
    window.open(url, '_blank');
  }
};

// Swiper 생성 함수
const createSwiper = async () => {
  if (!props.banners.length) return;

  if (swiperInstance.value) {
    swiperInstance.value.destroy(true, true);
    swiperInstance.value = null;
  }

  await nextTick();

  const isMobile = windowWidth.value < 1400;
  const bannerCount = props.banners.length;
  const slidesPerView = bannerCount === 1 ? 1 : isMobile ? 1 : Math.min(2, bannerCount);

  swiperInstance.value = new Swiper(swiperContainer.value, {
    loop: bannerCount > 1,
    slidesPerView,
    spaceBetween: 11,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    observer: true,
    observeParents: true,
  });
};

// 창 크기 변경 감지
const onResize = () => {
  windowWidth.value = window.innerWidth;
};

// resize 감지 후 swiper 재생성
watch(windowWidth, () => {
  createSwiper();
});

onMounted(() => {
  window.addEventListener('resize', onResize);
  createSwiper();
});

onBeforeUnmount(() => {
  if (swiperInstance.value) swiperInstance.value.destroy();
  window.removeEventListener('resize', onResize);
});
</script>

<style scoped>
.section02 {
  overflow-x: hidden;
}

.section02 .swiper .swiper-wrapper {
  display: flex;
}

.section02 .swiper .swiper-wrapper .swiper-slide {
  flex-shrink: 0;
  box-sizing: border-box;
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
